import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getCustomPagesByLanguage = async (languageCode) => {
    const response = await axiosInstance.get(API_ENDPOINTS.CUSTOM_PAGES.GET_BY_LANGUAGE(languageCode));
    return response.data?.data || [];
};

export const getCustomPageBySlug = async (slug, languageCode = 'vi') => {
    const response = await axiosInstance.get(API_ENDPOINTS.CUSTOM_PAGES.GET_BY_SLUG(slug, languageCode));
    return response.data?.data || null;
};
